import { render, staticRenderFns } from "./subscriptionList.vue?vue&type=template&id=2dcdb786&scoped=true"
import script from "./subscriptionList.vue?vue&type=script&lang=js"
export * from "./subscriptionList.vue?vue&type=script&lang=js"
import style0 from "./subscriptionList.vue?vue&type=style&index=0&id=2dcdb786&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcdb786",
  null
  
)

export default component.exports